import { useRef } from 'react'

import { ChatRefsContext } from './ChatRefsContext'

export function ChatRefsProvider({ children }) {
  // This ref is attached to a DOM node (<div ref={liveTextRef} />) to receive
  // incremental streaming text updates without forcing React re-renders.
  const liveTextRef = useRef(null)
  const lastAgentMessageRef = useRef(null)
  const setLastAgentMessageRef = el => {
    lastAgentMessageRef.current = el
  }
  const messagesContainerRef = useRef(null)
  return (
    <ChatRefsContext.Provider
      value={{
        messagesContainerRef,
        lastAgentMessageRef,
        setLastAgentMessageRef,
        liveTextRef,
      }}
    >
      {children}
    </ChatRefsContext.Provider>
  )
}
